import {query} from "../../utilities/query";
import {createAction} from "redux-actions";

export const fetchTemplates = Object.assign(
  () => dispatch => dispatch(query(fetchTemplates)("/api/template", "GET")),
  {
    success: createAction("templates/FETCH_SUCCESS"),
    failure: createAction("templates/FETCH_FAILURE")
  }
);
